import { SR_API_ACTION_GET_USER_SEARCH_QUERIES } from 'api/actionTypes';

export default async function getSearchQueries({ state, apiClient }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_GET_USER_SEARCH_QUERIES,
    state: state,
    onSuccess(recentSearchQueries) {
      state.set(['recentSearchQueries'], recentSearchQueries);
    },
  });
}
